/* eslint-disable max-len */
import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const UsersIcon: React.FC<IconProps> = props => {
  return (
    <BaseIcon {...props}>
      <path d="M11 15c2.2 0 4.191 1.445 5.637 3.78C17.892 17.655 19.39 17 21 17c3.922 0 7.186 3.882 7.869 9.005.146 1.095-.765 1.995-1.87 1.995H5c-1.104 0-2.01-.898-1.906-1.997C3.685 19.772 7 15 11 15Zm10 4c-1.149 0-2.367.568-3.406 1.643.665 1.57 1.125 3.39 1.312 5.357h7.94c-.69-4.487-3.427-7-5.846-7Zm-10-2c-1.14 0-2.431.679-3.602 2.324C6.263 20.92 5.395 23.248 5.105 26h11.79c-.29-2.753-1.158-5.08-2.294-6.676C13.431 17.68 12.14 17 11 17ZM21 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM11 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" />{' '}
    </BaseIcon>
  );
};
